import { AuthConfig } from 'angular-oauth2-oidc';

export const AuthCodeFlowConfig: AuthConfig = {
  // Url of the Identity Provider
  issuer: 'https://idp.pulse.cloud',

  // URL of the SPA to redirect the user to after login
  redirectUri: window.location.origin + window.location.pathname, //'http://localhost:1337/project/1', // window.location.host, //+ '/index.html',
  redirectUriAsPostLogoutRedirectUriFallback: false,
  // defaults to true for implicit flow and false for code flow
  // as for code code the default is using a refresh_token
  // Also see docs section 'Token Refresh'
  // useSilentRefresh: true,

  // The SPA's id. The SPA is registerd with this id at the auth-server
  // clientId: 'server.code',
  clientId: 'pulse-frontend',

  // Just needed if your auth server demands a secret. In general, this
  // is a sign that the auth server is not configured with SPAs in mind
  // and it might not enforce further best practices vital for security
  // such applications.
  // dummyClientSecret: 'secret',

  responseType: 'code',

  // set the scope for the permissions the client should request
  // The first four are defined by OIDC.
  // Important: Request offline_access to get a refresh token
  // The api scope is a usecase specific one
  scope: 'pulse profile',

  showDebugInformation: false,
  clearHashAfterLogin: true,
};
